"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientStyleProvider = void 0;
const React = require("react");
const StyleProvider_1 = require("../../../components/StyleProvider");
const BaseProvider_1 = require("../../BaseProvider");
class ClientStyleProvider extends BaseProvider_1.BaseProvider {
    constructor() {
        super(new Set());
        this.handleCSS = this.handleCSS.bind(this);
    }
    component(children) {
        return React.createElement(StyleProvider_1.StyleProvider, { onInsertCss: this.handleCSS }, children);
    }
    handleCSS(...styles) {
        styles.forEach((style) => style._insertCss());
    }
}
exports.ClientStyleProvider = ClientStyleProvider;
//# sourceMappingURL=ClientStyleProvider.js.map